function t(n, g) {
  return g.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&").split(/\s+/).reduce((e, r) => r.length <= 1 ? e : e.replace(
    new RegExp(r, "gi"),
    (i) => `<mark>${i}</mark>`
  ), n);
}
export {
  t as highlightText
};
